/**
 * The Atlas and the day's end.
 *
 * Everything here is the player's own: islands they charted, relics they won,
 * fragments they hold, manuscript spans they have unlocked, and their seal.
 * Nobody sees anybody else's, and there is no leaderboard (Q5.4).
 */

import { z } from 'zod'
import { shareCardSchema } from '../share-card.ts'
import { dayStatusSchema, gameDaySchema, islandNameSchema, reputationTierSchema } from './common.ts'

/** One island in the Atlas. */
export const atlasIslandSchema = z.object({
  day: gameDaySchema,
  dayNumber: z.number().int().positive().nullable(),
  islandName: islandNameSchema,
  status: dayStatusSchema,
  /** Everything charted, replay included, in [0, 1]. */
  completion: z.number().min(0).max(1),
  /** The live-day figure the share card quotes, frozen at finalisation. */
  liveCompletion: z.number().min(0).max(1).nullable(),
  /** A row-major string of glyphs for the thumbnail, unknown where unseen. */
  thumbnail: z.string(),
})

export const atlasRelicSchema = z.object({
  relicId: z.string(),
  day: gameDaySchema,
  islandName: islandNameSchema,
})

export const atlasResponseSchema = z.object({
  islands: z.array(atlasIslandSchema),
  relics: z.array(atlasRelicSchema),
  /** Fragments held, by catalogue id. The client renders the text. */
  fragmentIds: z.array(z.string()),
  /** Manuscript spans legible so far, by id, in reading order (Q6.4). */
  manuscriptSpanIds: z.array(z.string()),
  seal: reputationTierSchema,
})
export type ApiAtlas = z.infer<typeof atlasResponseSchema>

/** `GET /api/day/:day/share.json`. The `.txt` form is the rendered card. */
export const shareCardResponseSchema = shareCardSchema

export const healthResponseSchema = z.object({
  ok: z.literal(true),
  /** Migrations applied, so a deploy can be checked without a shell. */
  version: z.string(),
})
